/* NiZED Effects — Shopify Fabric */
(function () {
  'use strict';

  function setVh() { document.documentElement.style.setProperty('--vh', window.innerHeight + 'px'); }
  setVh(); window.addEventListener('resize', setVh);

  /* ── STYLE INJECTION — lädt als letztes, überschreibt App-CSS ── */
  (function () {
    var s = document.createElement('style');
    s.textContent =
      /* Scrollbar */
      '::-webkit-scrollbar{height:6px;width:6px}' +
      '::-webkit-scrollbar-track{background:rgba(255,255,255,0.06)}' +
      '::-webkit-scrollbar-thumb{background:#B00000;border-radius:3px}' +
      '::-webkit-scrollbar-thumb:hover{background:#E31E1E}' +

      /* ───────────────────────────────────────────────
         NAV DROPDOWN + MOBILE DRAWER FIX
         Lila kommt von Fabric-color-scheme-Variablen die
         --color-foreground auf purple setzen.
         Lösung: Variablen selbst überschreiben + color force.
      ─────────────────────────────────────────────── */

      /* CSS-Variablen im gesamten Navigationsbereich zurücksetzen */
      'header-drawer,' +
      '.header-drawer,' +
      '.mega-menu__list,' +
      '.menu-list__submenu,' +
      '.mega-menu{' +
        '--color-foreground:rgb(255,255,255);' +
        '--color-foreground-rgb:255 255 255;' +
        '--color-foreground-heading:rgb(255,255,255);' +
        '--color-foreground-heading-rgb:255 255 255;' +
        '--color-primary:rgb(255,255,255);' +
        '--color-primary-rgb:255 255 255;' +
      '}' +
      /* Alle color-scheme Klassen innerhalb der Nav überschreiben */
      'header-drawer [class*="color-"],' +
      '.header-drawer [class*="color-"],' +
      '.mega-menu [class*="color-"],' +
      '.mega-menu__list [class*="color-"],' +
      '.menu-list__submenu [class*="color-"]{' +
        '--color-foreground:rgb(255,255,255)!important;' +
        '--color-foreground-rgb:255 255 255!important;' +
        '--color-foreground-heading:rgb(255,255,255)!important;' +
        '--color-primary:rgb(255,255,255)!important;' +
      '}' +
      /* Force white text auf alle Links und Text-Elemente in der Nav */
      'header-drawer a,' +
      'header-drawer li,' +
      'header-drawer p,' +
      'header-drawer span:not([class*="svg"]):not([class*="icon"]),' +
      '.header-drawer a,' +
      '.header-drawer li,' +
      '.mega-menu a,' +
      '.mega-menu li,' +
      '.mega-menu__list a,' +
      '.mega-menu__list li,' +
      '.menu-list__submenu a,' +
      '.menu-list__submenu li{color:rgba(255,255,255,0.95)!important;}' +
      'header-drawer a:hover,' +
      '.header-drawer a:hover,' +
      '.mega-menu a:hover,' +
      '.menu-list__submenu a:hover{color:#FFFFFF!important;}' +

      /* "Home" Link → NiZED Rot */
      'a.menu-list__link[href="/"],' +
      '.menu-list__link[href="/"],' +
      'header-drawer a[href="/"],' +
      '.header-drawer a[href="/"],' +
      '.menu-drawer a[href="/"]{color:#B00000!important;}' +

      /* Mega-Menu Kategorie-Headings */
      '.mega-menu__heading,.mega-menu h2,.mega-menu h3,.mega-menu h4,' +
      '.menu-drawer__menu-heading{color:rgba(255,255,255,0.5)!important;}';

    document.head.appendChild(s);
  })();

  /* ── CURSOR ── */
  var cDot  = document.getElementById('nz-c-dot');
  var cRing = document.getElementById('nz-c-ring');
  if (cDot && cRing && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 769px)').matches) {
    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var rx = mx, ry = my;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function animCursor() {
      rx += (mx - rx) * 0.10; ry += (my - ry) * 0.10;
      cDot.style.left = mx + 'px'; cDot.style.top = my + 'px';
      cRing.style.left = rx + 'px'; cRing.style.top = ry + 'px';
      requestAnimationFrame(animCursor);
    })();
    document.querySelectorAll('a, button, .card-wrapper, .nz-coll-card, .nz-btn, .magnetic, [role="button"]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { document.body.classList.add('nz-hovering'); });
      el.addEventListener('mouseleave', function () { document.body.classList.remove('nz-hovering'); });
    });
    document.addEventListener('mousedown', function () { document.body.classList.add('nz-clicking'); });
    document.addEventListener('mouseup', function () { document.body.classList.remove('nz-clicking'); });
  }

  /* ── CART NOTE ── */
  function insertNativeCartNote() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('cart-drawer-component').forEach(function (cartDrawer) {
      var root = cartDrawer.querySelector('.cart-drawer__inner') || cartDrawer.querySelector('.cart-drawer__content') || cartDrawer;
      if (!root || cartDrawer.querySelector('.nz-native-cart-note')) return;
      var noteWrap = document.createElement('div');
      noteWrap.className = 'nz-native-cart-note';
      noteWrap.innerHTML =
        '<label class="nz-native-cart-note__label" for="nz-native-cart-note-input">Notiz hinzuf&uuml;gen</label>' +
        '<textarea id="nz-native-cart-note-input" class="nz-native-cart-note__input" rows="3" placeholder="Besondere W&uuml;nsche zur Bestellung"></textarea>' +
        '<p class="nz-native-cart-note__discount">Rabattcodes und Gutscheine k&ouml;nnen im Checkout eingegeben werden.</p>' +
        '<div class="nz-cart-trust" aria-label="Sicher bezahlen"><span class="nz-cart-trust__label">Sicher bezahlen mit</span><span class="nz-cart-payments" aria-hidden="true"><span>Visa</span><span>MC</span><span>PayPal</span><span>Klarna</span><span>Apple Pay</span></span></div>';
      var summary = cartDrawer.querySelector('.cart-drawer__summary');
      var discount = cartDrawer.querySelector('cart-discount, .cart-discount, [class*="discount"], [data-discount]');
      var checkout = summary ? summary.querySelector('button[name="checkout"], .cart__checkout-button, a[href="/checkout"]') : null;
      if (discount && discount.parentNode) { discount.insertAdjacentElement('afterend', noteWrap); }
      else if (checkout && checkout.parentNode) { checkout.parentNode.insertBefore(noteWrap, checkout); }
      else if (summary) { summary.insertBefore(noteWrap, summary.firstChild); }
      else { root.appendChild(noteWrap); }
      noteWrap.querySelector('textarea').addEventListener('change', function (event) {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ note: event.target.value }) }).catch(function () {});
      });
    });
  }
  if (document.querySelector('cart-drawer-component')) {
    insertNativeCartNote();
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('cart-drawer-component, [data-testid="cart-drawer-trigger"], form[action*="/cart/add"]')) {
        setTimeout(insertNativeCartNote, 150); setTimeout(insertNativeCartNote, 600);
      }
    });
  }

  /* ── WALDGRUEN SWATCHES ── */
  function applyWaldgruenSwatches() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('product-swatches, .variant-option--swatches').forEach(function (group) {
      group.querySelectorAll('button, label, .variant-option__button-label, .swatch').forEach(function (el) {
        var text = (el.textContent || '').trim().toLowerCase();
        var label = [el.getAttribute('aria-label'), el.getAttribute('title'), el.getAttribute('data-option-value'), el.getAttribute('data-value'), el.getAttribute('value')].filter(Boolean).join(' ').toLowerCase();
        if (!/(^|\s)(wal|waldgruen|waldgrün|wald green|forest green)(\s|$)/.test(text + ' ' + label)) return;
        var swatch = el.classList.contains('swatch') ? el : el.querySelector('.swatch') || el;
        swatch.style.setProperty('background', '#2f4f2f', 'important'); swatch.style.setProperty('background-color', '#2f4f2f', 'important'); swatch.style.setProperty('background-image', 'none', 'important'); swatch.style.setProperty('color', 'transparent', 'important'); swatch.style.setProperty('text-shadow', 'none', 'important'); swatch.setAttribute('data-nz-fixed-swatch', 'waldgruen');
      });
    });
  }
  if (document.querySelector('product-swatches, .variant-option--swatches')) {
    applyWaldgruenSwatches();
    document.addEventListener('change', applyWaldgruenSwatches);
    document.addEventListener('click', function () { setTimeout(applyWaldgruenSwatches, 100); });
  }

  /* ── HIDDEN CLOTHING SIZES ── */
  function applyHiddenClothingSizes() {
    var hiddenSizes = ['3xl', '4xl', '5xl', 'xxxl', 'xxxxl', 'xxxxxl'];
    function normalize(v) { return String(v || '').toLowerCase().replace(/[\s_-]/g, ''); }
    function isHidden(v) { return hiddenSizes.indexOf(normalize(v)) !== -1; }
    function labelFor(el) { return [el.getAttribute('data-value'), el.getAttribute('data-option-value'), el.getAttribute('aria-label'), el.getAttribute('title'), el.getAttribute('value'), el.textContent].filter(Boolean).join(' '); }
    document.querySelectorAll('button, label, option, input[type="radio"], input[type="button"], .variant-option__button-label, .nz-size-btn').forEach(function (el) {
      if (!isHidden(labelFor(el))) return;
      var target = el;
      if (el.tagName === 'INPUT') { var lbl = null; if (el.id && window.CSS && CSS.escape) lbl = document.querySelector('label[for="' + CSS.escape(el.id) + '"]'); target = lbl || el.closest('label') || el; el.disabled = true; }
      if (el.tagName === 'OPTION') { el.disabled = true; el.hidden = true; }
      target.setAttribute('hidden', 'hidden'); target.setAttribute('aria-hidden', 'true');
      target.style.setProperty('display', 'none', 'important'); target.style.setProperty('visibility', 'hidden', 'important'); target.style.setProperty('pointer-events', 'none', 'important');
    });
  }
  applyHiddenClothingSizes();
  document.addEventListener('change', applyHiddenClothingSizes);
  document.addEventListener('click', function () { setTimeout(applyHiddenClothingSizes, 80); });

  /* ── 3D TILT ── */
  function applyTilt(el) {
    el.addEventListener('mousemove', function (e) { var r = el.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - 0.5; var y = (e.clientY - r.top) / r.height - 0.5; el.style.transition = 'transform 0.08s ease, box-shadow 0.3s ease'; el.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) scale(1.02)'; });
    el.addEventListener('mouseleave', function () { el.style.transition = 'transform 0.6s cubic-bezier(0.16,1,0.3,1), box-shadow 0.6s ease'; el.style.transform = ''; });
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.card-wrapper, .nz-coll-card').forEach(applyTilt);

    /* ── MAGNETIC BUTTONS ── */
    document.querySelectorAll('.magnetic, .nz-btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) { var r = btn.getBoundingClientRect(); btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.42) + 'px, ' + ((e.clientY - r.top - r.height / 2) * 0.42) + 'px)'; });
      btn.addEventListener('mouseleave', function () { btn.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)'; btn.style.transform = ''; setTimeout(function () { btn.style.transition = ''; }, 500); });
    });
  }

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('revealed'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* ── COOKIE BANNER ── */
  var cookieBanner = document.getElementById('nz-cookie-banner');
  var cookieOverlay = document.getElementById('nz-cookie-overlay');
  var nzStoredCookieDecision = null;
  try { nzStoredCookieDecision = localStorage.getItem('nized_cookie_ok'); } catch (error) {}
  var nzCookieDecisionMade = nzStoredCookieDecision !== null;
  function nzShowCookieBanner() {
    if (!cookieBanner || nzCookieDecisionMade) return;
    cookieBanner.classList.remove('nz-hidden');
    cookieBanner.classList.add('nz-active');
    if (cookieOverlay) { cookieOverlay.classList.add('nz-active'); }
    document.body.style.overflow = 'hidden';
  }
  function nzHideCookieBanner() {
    if (cookieBanner) {
      cookieBanner.classList.remove('nz-active');
      cookieBanner.classList.add('nz-hidden');
    }
    if (cookieOverlay) { cookieOverlay.classList.remove('nz-active'); }
    document.body.style.overflow = '';
  }
  function nzSetTrackingConsent(accepted) {
    nzCookieDecisionMade = true;
    nzStoredCookieDecision = accepted ? '1' : '0';
    try { localStorage.setItem('nized_cookie_ok', nzStoredCookieDecision); } catch (error) {}
    /* Der Kund:innen-Klick muss die Oberfläche sofort freigeben. Shopifys
       Callback kann in der Theme-Vorschau oder bei blockierten Skripten
       verzögert bzw. gar nicht zurückkommen. */
    nzHideCookieBanner();
    var privacy = window.Shopify && Shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      return;
    }
    try {
      privacy.setTrackingConsent({
        analytics: accepted,
        marketing: accepted,
        preferences: accepted
      }, function() {});
    } catch (error) {}
  }
  function nzInitCookieBanner() {
    if (!cookieBanner) return;
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(error) {
        var privacy = !error && window.Shopify ? Shopify.customerPrivacy : null;
        if (privacy && nzStoredCookieDecision !== null && typeof privacy.setTrackingConsent === 'function') {
          try {
            privacy.setTrackingConsent({
              analytics: nzStoredCookieDecision === '1',
              marketing: nzStoredCookieDecision === '1',
              preferences: nzStoredCookieDecision === '1'
            }, function() {});
          } catch (consentError) {}
          return;
        }
        if (privacy && typeof privacy.shouldShowBanner === 'function') {
          if (privacy.shouldShowBanner()) nzShowCookieBanner();
          return;
        }
        if (nzStoredCookieDecision === null) nzShowCookieBanner();
      });
      return;
    }
    if (nzStoredCookieDecision === null) nzShowCookieBanner();
  }
  nzInitCookieBanner();
  window.nzAcceptCookies = function () { nzSetTrackingConsent(true); };
  window.nzDeclineCookies = function () { nzSetTrackingConsent(false); };

  /* ── CART PAGE WISHLIST BUTTONS ── */
  function nzInjectCartPageWishBtns() {
    if (!document.querySelector('main[data-template="cart"]')) return;
    document.querySelectorAll('tr.cart-items__table-row').forEach(function (row) {
      if (row.querySelector('.nz-cpw')) return;
      var removeBtn = row.querySelector('.cart-items__remove');
      if (!removeBtn) return;
      var titleLink = row.querySelector('a.cart-items__title');
      var imgEl     = row.querySelector('.cart-items__media-image, img');
      var priceEl   = row.querySelector('.cart-items__price, [class*="price"]');
      var url    = titleLink ? (titleLink.getAttribute('href') || '') : '';
      var handle = (url.split('/products/')[1] || '').split('?')[0].split('/')[0];
      if (!handle) return;
      var title = titleLink ? titleLink.textContent.trim() : '';
      var image = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '').split('?')[0] : '';
      var price = priceEl ? priceEl.textContent.trim() : '';
      var wishBtn = document.createElement('button');
      wishBtn.type = 'button';
      wishBtn.className = 'nz-cpw';
      wishBtn.setAttribute('aria-label', 'Zur Wunschliste');
      wishBtn.innerHTML = '♡';
      wishBtn.dataset.handle = handle;
      wishBtn.dataset.title  = title;
      wishBtn.dataset.url    = url;
      wishBtn.dataset.price  = price;
      wishBtn.dataset.image  = image;
      if (window.NzWishlist && NzWishlist.has(handle)) { wishBtn.innerHTML = '♥'; wishBtn.classList.add('active'); }
      wishBtn.addEventListener('click', function () {
        if (!window.NzWishlist) return;
        NzWishlist.toggle({ handle: wishBtn.dataset.handle, title: wishBtn.dataset.title, url: wishBtn.dataset.url, price: wishBtn.dataset.price, image: wishBtn.dataset.image }, wishBtn);
      });
      removeBtn.insertAdjacentElement('afterend', wishBtn);
    });
  }
  if (document.querySelector('main[data-template="cart"]')) {
    document.addEventListener('DOMContentLoaded', nzInjectCartPageWishBtns);
    setTimeout(nzInjectCartPageWishBtns, 400);
    setTimeout(nzInjectCartPageWishBtns, 1200);
  }

})();


/* Keep the cookie notice non-blocking while it is visible. */
(function () {
  var overlay = document.getElementById('nz-cookie-overlay');
  var banner = document.getElementById('nz-cookie-banner');
  if (overlay) { overlay.classList.remove('nz-active'); }
  if (banner && banner.classList.contains('nz-active')) {
    document.body.style.overflow = '';
  }
})();
